export default "__VITE_ASSET__5b10c3e6__"